export const columnWidth = (1000 / 3);
export const includeChildrenOnSearch = true;
